import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import {
    HomeIcon,
    BuildingOffice2Icon,
    StarIcon,
    ShieldCheckIcon,
    CurrencyDollarIcon,
    ClockIcon,
    DocumentCheckIcon,
    CheckCircleIcon,
    SparklesIcon,
    BoltIcon,
    HeartIcon,
    LightBulbIcon,
    RocketLaunchIcon,
    ChartBarIcon,
    UserGroupIcon,
    BanknotesIcon,
    KeyIcon
} from '@heroicons/react/24/outline';

// Icon mapping
const iconMap = {
    HomeIcon,
    BuildingOffice2Icon,
    StarIcon,
    ShieldCheckIcon,
    CurrencyDollarIcon,
    ClockIcon,
    DocumentCheckIcon,
    CheckCircleIcon,
    SparklesIcon,
    BoltIcon,
    HeartIcon,
    LightBulbIcon,
    RocketLaunchIcon,
    ChartBarIcon,
    UserGroupIcon,
    BanknotesIcon,
    KeyIcon
};

const KeyBenefitCard = ({ benefit, onEdit, onDelete }) => {
    const IconComponent = iconMap[benefit.icon_name] || StarIcon;

    return (
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-200 border border-slate-100">
            {/* Header with gradient */}
            <div className={`relative h-32 bg-gradient-to-br from-${benefit.gradient_from || 'blue-500'} to-${benefit.gradient_to || 'indigo-600'}`}>
                {/* Icon */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-16 h-16 rounded-2xl flex items-center justify-center bg-white/30 backdrop-blur-md shadow-lg border border-white/20">
                        <IconComponent className="h-8 w-8 text-white" />
                    </div>
                </div>

                {/* Display Order Badge */}
                <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-1.5 shadow-lg">
                    <span className="text-sm font-bold text-gray-700">
                        #{benefit.display_order || 0}
                    </span>
                </div>

                {/* Active/Inactive Badge */}
                <div className="absolute top-3 left-3">
                    <span className={`px-3 py-1.5 rounded-lg text-xs font-semibold shadow-lg ${benefit.is_active
                        ? 'bg-green-500 text-white'
                        : 'bg-slate-400 text-white'
                        }`}>
                        {benefit.is_active ? 'Active' : 'Inactive'}
                    </span>
                </div>
            </div>

            {/* Content */}
            <div className="p-5">
                {/* Title */}
                <h3 className="text-lg font-bold text-slate-800 mb-2 line-clamp-1">
                    {benefit.title}
                </h3>

                {/* Description */}
                <p className="text-sm text-slate-500 mb-4 line-clamp-3">
                    {benefit.description}
                </p>

                {/* Icon Name Tag */}
                <div className="mb-4">
                    <span className="px-2 py-1 bg-indigo-50 text-indigo-600 text-xs font-medium rounded-md">
                        {benefit.icon_name}
                    </span>
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2 pt-4 border-t border-slate-100">
                    <button
                        onClick={() => onEdit(benefit)}
                        className="flex-1 flex items-center justify-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <PencilIcon className="h-4 w-4" />
                        Edit
                    </button>
                    <button
                        onClick={() => onDelete(benefit.id)}
                        className="flex-1 flex items-center justify-center gap-2 bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2.5 rounded-xl font-medium transition-all duration-200"
                    >
                        <TrashIcon className="h-4 w-4" />
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default KeyBenefitCard;
